import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import HeroSection from "./components/HeroSection";
import CategoryDropdown from "./components/CategoryDropdown";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import WhySection from "./components/WhySection";
import ArticlesSection from "./components/ArticlesSection";
import GuideCta from "./components/GuideCta";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://yoybuy.help/#website",
  "url": "https://yoybuy.help/",
  "name": "Yoybuy Sheet — Таблицы для шоппинга",
  "description": "Yoybuy Sheet — полные таблицы со ссылками на товары для шоппинга через Yoybuy. Обувь, одежда, аксессуары, сумки и многое другое. Найдите лучшие находки с нашими гайдами и таблицами.",
  "inLanguage": "ru-RU",
  "publisher": {
    "@type": "Organization",
    "name": "Yoybuy Sheet",
    "url": "https://yoybuy.help/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg"
    }
  }
};

export default function Home() {
  return (
    <main>
      <JsonLd data={homeSchema} />
      <Navbar />
      <HeroSection />
      <CategoryDropdown />
      <CategoryGrid />
      <AboutSection />
      <WhySection />
      <ArticlesSection />
      <GuideCta />
      <Footer />
    </main>
  );
}